module.exports = __webpack_public_path__ + "img/logo.037cafc0.png";